/* @flow */
import React from 'react';
import AccountLinkingComposerSidebarContent from './AccountLinkingComposerSidebarContent';
import AccountLinkingComposerSidebarServices from './AccountLinkingComposerSidebarServices';
import AccountLinkingComposerSidebarServicesContainer from '../containers/AccountLinkingComposerSidebarServicesContainer';

type Props = {
  fetchPolicy?: string,
  addLinkedContent: (*) => void,
};

type State = {
  viewingSource: ?*,
};

class AccountLinkingComposerSidebar extends React.Component<Props, State> {
  state: State = {
    viewingSource: null,
  };

  viewContent = (contentSource: *) => {
    this.setState({
      viewingSource: contentSource,
    });
  };

  viewSources = () => {
    this.setState({
      viewingSource: null,
    });
  };

  render() {
    const { addLinkedContent } = this.props;
    const { viewingSource } = this.state;

    if (viewingSource == null) {
      return (
        <AccountLinkingComposerSidebarServicesContainer fetchPolicy={this.props.fetchPolicy}>
          {({ loading, sources, error, refetch }) => (
            <AccountLinkingComposerSidebarServices
              error={error}
              sources={sources}
              loading={loading}
              onViewContent={this.viewContent}
              reloadContentSources={refetch}
            />
          )}
        </AccountLinkingComposerSidebarServicesContainer>
      );
    } else {
      return (
        <AccountLinkingComposerSidebarContent
          onViewSources={this.viewSources}
          addLinkedContent={addLinkedContent}
          contentSource={viewingSource}
        />
      );
    }
  }
}

export default AccountLinkingComposerSidebar;
